module.exports = __webpack_public_path__ + "static/media/bookmark.e55ffc0e.svg";